import { Button, Collapse, Stack, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type FC, type PropsWithChildren, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const PageResources = Resources.Portfolio.AddRealEstate;

type Props = {
	disclosurePlacement: "top" | "bottom";
};

export const BuildingExtendedParams: FC<PropsWithChildren<Props>> = ({
	disclosurePlacement,
	children,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const [expanded, setExpanded] = useState(false);

	return (
		<>
			{disclosurePlacement === "bottom" && (
				<Collapse in={expanded} timeout="auto" unmountOnExit>
					<Stack>{children}</Stack>
				</Collapse>
			)}
			<Button
				variant="disclosure"
				aria-expanded={expanded}
				onClick={() => setExpanded((prev) => !prev)}
				endIcon={
					expanded ? (
						<ChevronUp size={theme.iconSize.sm} />
					) : (
						<ChevronDown size={theme.iconSize.sm} />
					)
				}
			>
				{t(
					expanded
						? PageResources.hideParameters
						: PageResources.showParameters,
				)}
			</Button>
			{disclosurePlacement === "top" && (
				<Collapse in={expanded} timeout="auto" unmountOnExit>
					<Stack>{children}</Stack>
				</Collapse>
			)}
		</>
	);
};
